import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { IMaskInput } from 'react-imask';
import { InputBaseComponentProps } from '@mui/material/InputBase/InputBase';
import { pinCursorToStartIfInputPlaceholder } from './utils/pinCursorToStartIfInputPlaceholder';

const maskPlaceholder = 'XX YY ZZ';

export const ReferralCodeMask = forwardRef(
  (props: InputBaseComponentProps, ref) => {
    const { onChange, ...other } = props;
    const maskedInputRef = useRef(null);

    useImperativeHandle(ref, () => maskedInputRef.current);

    return (
      <IMaskInput
        mask={RegExp(/^[a-zA-Z0-9]+$/)}
        lazy={false}
        autofix={true}
        overwrite={true}
        unmask={false}
        onAccept={(val) => {
          onChange({
            target: {
              name: props.name,
              value: val.toString().toUpperCase(),
            },
          } as any);
        }}
        inputMode={'text'}
        {...other}
        ref={maskedInputRef}
        onFocus={() => {
          pinCursorToStartIfInputPlaceholder(
            maskPlaceholder,
            maskedInputRef.current.element,
          );
        }}
      />
    );
  },
);

ReferralCodeMask.displayName = 'ReferralCodeMask';
